import {FaTrash} from "react-icons/fa";
import {FaPencil} from "react-icons/fa6";
import {getUrl} from "../../../constants/urls";

export const customFieldChoicesListUrl = getUrl("customFieldChoices");

export const ACTIONS_LIST = [
  {label: "Edit", icon: FaPencil, perms: ["change_customfieldchoiceset"]},
  {label: "Delete", icon: FaTrash, perms: ["delete_customfieldchoiceset"]},
];

export const PERMS_FOR_ACTIONS = [
  "change_customfieldchoiceset",
  "delete_customfieldchoiceset",
];

export const LIST_HEADERS = ["name", "description", "order_alphabetically"];
